export default __webpack_public_path__ + "static/media/1233idjlksd.0dbd2bca.png";